import { render } from "./JoinMeeting.vue?vue&type=template&id=0652ca6c"
import script from "./JoinMeeting.vue?vue&type=script&lang=js"
export * from "./JoinMeeting.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__